import { render } from "./TeamListCard.vue?vue&type=template&id=22aec696"
import script from "./TeamListCard.vue?vue&type=script&lang=js"
export * from "./TeamListCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__